import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import PricingCard from './PricingCard'
import { Button, useDisclosure } from '@nextui-org/react-latest'
import { useTranslation } from 'react-i18next'
import ConnectWithUsModal from '@components/organisms/ConnectWithUsModal'

type Props = {}

const EdugramPricing = ({}: Props) => {
  const { t } = useTranslation('advantageous')
  const { isOpen, onOpen, onOpenChange } = useDisclosure()

  const data = [
    {
      title: t('pricing.byCreator.title'),
      caption: t('pricing.byCreator.caption'),
      subTitle: t('pricing.byCreator.subTitle'),
      listTitle: t('pricing.byCreator.listTitle'),
      isHighlighted: false,
      extraContent: null,
      list: [
        {
          title: t('pricing.byCreator.list.selfPromote'),
          description: t('pricing.byCreator.list.selfPromoteDescription'),
        },
        {
          title: t('pricing.byCreator.list.intuitiveCourseBuilding'),
          description: t(
            'pricing.byCreator.list.intuitiveCourseBuildingDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.managePricing'),
          description: t('pricing.byCreator.list.managePricingDescription'),
        },
        {
          title: t('pricing.byCreator.list.preReleasePromotion'),
          description: t(
            'pricing.byCreator.list.preReleasePromotionDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.scheduleCourseRelease'),
          description: t(
            'pricing.byCreator.list.scheduleCourseReleaseDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.automaticGlobalPayments'),
          description: t(
            'pricing.byCreator.list.automaticGlobalPaymentsDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.advancedContentProtection'),
          description: t(
            'pricing.byCreator.list.advancedContentProtectionDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.gamifiedLearning'),
          description: t('pricing.byCreator.list.gamifiedLearningDescription'),
        },
        {
          title: t('pricing.byCreator.list.trackYourSuccess'),
          description: t('pricing.byCreator.list.trackYourSuccessDescription'),
        },
        {
          title: t('pricing.byCreator.list.flexiblePayoutOptions'),
          description: t(
            'pricing.byCreator.list.flexiblePayoutOptionsDescription'
          ),
        },
        {
          title: t('pricing.byCreator.list.autoTranslatedSubtitles'),
          description: t(
            'pricing.byCreator.list.autoTranslatedSubtitlesDescription'
          ),
        },
      ],
    },
    {
      title: t('pricing.byEdugram.title'),
      caption: t('pricing.byEdugram.caption'),
      subTitle: t('pricing.byEdugram.subTitle'),
      listTitle: t('pricing.byEdugram.listTitle'),
      isHighlighted: true,
      extraContent: null,

      list: [
        {
          title: t('pricing.byEdugram.list.automatedSales'),
          description: t('pricing.byEdugram.list.automatedSalesDescription'),
        },
        {
          title: t('pricing.byEdugram.list.personalizedLearningPaths'),
          description: t(
            'pricing.byEdugram.list.personalizedLearningPathsDescription'
          ),
        },
        {
          title: t('pricing.byEdugram.list.smartPricing'),
          description: t('pricing.byEdugram.list.smartPricingDescription'),
        },
        {
          title: t('pricing.byEdugram.list.automaticCourseBundling'),
          description: t(
            'pricing.byEdugram.list.automaticCourseBundlingDescription'
          ),
        },
        {
          title: t('pricing.byEdugram.list.freeAudioTranslation'),
          description: t(
            'pricing.byEdugram.list.freeAudioTranslationDescription'
          ),
        },
        {
          title: t('pricing.byEdugram.list.support'),
          description: t('pricing.byEdugram.list.supportDescription'),
        },
        {
          title: t('pricing.byEdugram.list.deepInsights'),
          description: t('pricing.byEdugram.list.deepInsightsDescription'),
        },
        {
          title: t('pricing.byEdugram.list.expandReach'),
          description: t('pricing.byEdugram.list.expandReachDescription'),
        },
        {
          title: t('pricing.byEdugram.list.giftCourses'),
          description: t('pricing.byEdugram.list.giftCoursesDescription'),
        },
        {
          title: t('pricing.byEdugram.list.bundleCourses'),
          description: t('pricing.byEdugram.list.bundleCoursesDescription'),
        },
        {
          title: t('pricing.byEdugram.list.sellDigitalContent'),
          description: t(
            'pricing.byEdugram.list.sellDigitalContentDescription'
          ),
        },
        {
          title: t('pricing.byEdugram.list.hostLiveClasses'),
          description: t('pricing.byEdugram.list.hostLiveClassesDescription'),
        },
        {
          title: t('pricing.byEdugram.list.stayUpdated'),
          description: t('pricing.byEdugram.list.stayUpdatedDescription'),
        },
      ],
    },
    {
      title: t('pricing.enterprise.title'),
      caption: t('pricing.enterprise.caption'),
      subTitle: t('pricing.enterprise.subTitle'),
      listTitle: t('pricing.enterprise.listTitle'),
      isHighlighted: false,
      extraContent: (
        <>
          <div>
            <Button
              className="h-[57.97px] px-6 font-[Helvetica] font-[400]"
              radius="full"
              color="secondary"
              style={{ border: '4px solid #B0B9FF' }}
              onPress={onOpen}
            >
              {t('pricing.enterprise.contactSales')}
            </Button>
          </div>
        </>
      ),
      list: [
        {
          title: t('pricing.enterprise.list.exclusiveCoursePublishing'),
          description: t(
            'pricing.enterprise.list.exclusiveCoursePublishingDescription'
          ),
        },
        {
          title: t('pricing.enterprise.list.comprehensiveOnboarding'),
          description: t(
            'pricing.enterprise.list.comprehensiveOnboardingDescription'
          ),
        },
        {
          title: t('pricing.enterprise.list.employeeTrainingPaths'),
          description: t(
            'pricing.enterprise.list.employeeTrainingPathsDescription'
          ),
        },
        {
          title: t('pricing.enterprise.list.manageAccess'),
          description: t('pricing.enterprise.list.manageAccessDescription'),
        },
        {
          title: t('pricing.enterprise.list.trackPerformance'),
          description: t('pricing.enterprise.list.trackPerformanceDescription'),
        },
        {
          title: t('pricing.enterprise.list.teamCollaboration'),
          description: t(
            'pricing.enterprise.list.teamCollaborationDescription'
          ),
        },
        {
          title: t('pricing.enterprise.list.customBranding'),
          description: t('pricing.enterprise.list.customBrandingDescription'),
        },
        {
          title: t('pricing.enterprise.list.hrIntegration'),
          description: t('pricing.enterprise.list.hrIntegrationDescription'),
        },
        {
          title: t('pricing.enterprise.list.brandedCertificates'),
          description: t(
            'pricing.enterprise.list.brandedCertificatesDescription'
          ),
        },
        {
          title: t('pricing.enterprise.list.customBusinessSolutions'),
          description: t(
            'pricing.enterprise.list.customBusinessSolutionsDescription'
          ),
        },
      ],
    },
  ]

  return (
    <Container>
      <Wrapper>
        <Top>
          <TopTitle>{t('pricing.title')}</TopTitle>
          <TopDescription>{t('pricing.description')}</TopDescription>
        </Top>
        <PricingContainer>
          {data.map((d, i) => (
            <PricingCard key={i} data={d} />
          ))}
        </PricingContainer>
      </Wrapper>
      <ConnectWithUsModal isOpen={isOpen} onOpenChange={onOpenChange} />
    </Container>
  )
}

export default EdugramPricing

const Container = styled.div`
  margin: 1rem 0rem;
  margin-top: 5rem;
  @media screen and (max-width: 1430px) {
    margin-top: 12rem;
    margin-bottom: 6rem;
    padding: 0px 1.5rem;
  }
`
const Wrapper = styled.div`
  max-width: 1430px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
`
const Top = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 681px;
  gap: 1rem;
`
const TopTitle = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 64px;
  font-weight: 600;
  line-height: 64px;
  text-align: center;
  color: ${colors.uguPurple};
  @media screen and (max-width: 540px) {
    font-size: 36px;
    line-height: 36px;
  }
`
const TopDescription = styled.div`
  font-family: ${fontFamilies.OpenSansRegular};
  font-size: 24px;
  font-weight: 500;
  line-height: 45px;
  text-align: center;
  color: ${colors.uguPurple};
  @media screen and (max-width: 540px) {
    font-size: 17px;
    line-height: 24px;
  }
`
const PricingContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media screen and (max-width: 1430px) {
    justify-content: center;
    flex-direction: column;
  }
`
// const Wrapper = styled.div``
